import { put } from '../../../api/client';
import { AvatarUploadControl } from '../../../components/feature/avatar';

interface AvatarUploaderProps {
  customerId: string;
  name: string | null;
  avatarUrl: string | null;
  onAvatarChange: (url: string) => void;
  onError?: (error: string) => void;
}

/**
 * 客户头像上传（客户详情页）。
 * 流程：上传 -> POST /uploads/avatar -> PUT /customers/:id 写回 avatar 字段。
 */
export default function AvatarUploader({ customerId, name, avatarUrl, onAvatarChange, onError }: AvatarUploaderProps) {
  const handleUploaded = async (url: string) => {
    try {
      await put(`/customers/${customerId}`, { avatar: url });
      onAvatarChange(url);
    } catch (error) {
      const msg = error instanceof Error ? error.message : '保存客户头像失败';
      onError?.(msg);
      throw error;
    }
  };

  return (
    <AvatarUploadControl
      name={name}
      avatarUrl={avatarUrl}
      onUploaded={handleUploaded}
      size="xl"
      label="点击更换客户头像"
    />
  );
}
